import { useContext, useEffect } from "react";
import { BaseStyles, FontStyles } from "../CurrencySEOCommonUI";
import CurrencyDocument from "./CurrencyDocument";
import { CurrencyConverterPageStyle } from "./CurrencyConverterPage.styles";
import Header from "./Header";
import Hero from "./Hero";
import { HeroWebV2 } from "../CurrencyPageTemplate/HeroWebV2";
import Introduction from "./Introduction";
import HowToConvert from "./HowToConvert";
import Benefits from "./Benefits";
import OtherServices from "./OtherServices";
import PopularDenomitations from "./PopularDenominations";
import CurrencyInformation from "./CurrencyInformation";
import { CurrencyFooter } from "../CurrencyPageTemplate/CurrencyFooter";
import OtherConversions from "./OtherConversions";
import CrossLobLinks from "../CurrencySEOCommonUI/CrossLobLinks";
import Faqs from "./Faqs";
import ConvertOnline from "./ConvertOnline";
import ForexProduct from "./ForexProducts";
import { CurrencySEOLayoutContext } from "../CurrencySEOLayoutContext";
import { PAGE_NAMES, trackSeoPageLoad } from "@tm/utility/analytics";
import Banner from "../CurrencyRatePageTemplate/Banner";
import { DEVICE_SIZES } from "../../static/utils";
import { ListingUiWrapper } from "@forex/listing-ui";
import { useBotDetection } from "../../hooks";

// Wrapper component to handle deviceType logic
const SectionWrapper = ({
  children,
  deviceType,
}: {
  children: React.ReactNode;
  deviceType: string | null;
}) => {
  if (deviceType === DEVICE_SIZES.LARGE) {
    return <div className="sectionWrapper">{children}</div>;
  }
  return <>{children}</>;
};

export const CurrencyConverterPageTemplate = ({
  id,
  currencyData,
  inrExchangeRate,
  currCodeToCurrRate,
  switchInrExchnageRate,
  templateType = "",
  page_name,
}: any) => {
  const { deviceType, newAddCurrencyFunnel } = useContext(
    CurrencySEOLayoutContext
  );
  const isBot = useBotDetection();

  useEffect(() => {
    trackSeoPageLoad({
      pageName: PAGE_NAMES["SEO_CURRENCY_CONVERTER"]?.replace(
        "NAME",
        `${currencyData?.curr_code}_to_INR`
      ),
      currency: currencyData?.curr_code,
      denomination: currencyData?.heroCurrencyDenominationVal,
    });
  }, []);

  const heading1 = currencyData?.hero?.title?.split("Currency Converter")[0];

  return (
    <div style={{ backgroundColor: "#F2F2F2" }}>
      <FontStyles />
      <BaseStyles />
      <CurrencyConverterPageStyle deviceType={deviceType} />

      <CurrencyDocument currencyData={currencyData} />
      <Header currencyData={currencyData} />
      {deviceType === DEVICE_SIZES.SMALL && (
        <Hero
          currencyData={currencyData}
          inrExchangeRate={inrExchangeRate}
          currCodeToCurrRate={currCodeToCurrRate}
          switchInrExchnageRate={switchInrExchnageRate}
          breadcrumb={currencyData?.breadcrumb}
          templateType={templateType}
        />
      )}
      {deviceType === DEVICE_SIZES.LARGE && (
        <HeroWebV2
          title={heading1}
          desc={currencyData?.hero?.desc}
          breadcrumb={currencyData?.breadcrumb || []}
        >
          <ListingUiWrapper
            source_type="seo"
            isBot={isBot}
            deviceType={deviceType}
            page_name={page_name}
          />
        </HeroWebV2>
      )}

      <div
        className={`pageContainerWrapper ${
          deviceType === DEVICE_SIZES.LARGE
            ? "pageContainerWrapper--large"
            : "pageContainerWrapper--small"
        }`}
      >
        <div className="pageContainer">
          <div
            className={
              deviceType === DEVICE_SIZES.SMALL ? "" : "oldProductsSection"
            }
          >
            <ForexProduct
              currencyData={currencyData}
              pageName={PAGE_NAMES["SEO_CURRENCY_CONVERTER"]?.replace(
                "NAME",
                `${currencyData?.curr_code}_to_INR`
              )}
              templateType={templateType}
            />
          </div>
          <div className="pageContent">
            <Banner currencyData={currencyData} />

            {currencyData?.introduction?.para && (
              <Introduction currencyData={currencyData} />
            )}

            <SectionWrapper deviceType={deviceType}>
              <ConvertOnline currencyData={currencyData} />
            </SectionWrapper>

            <SectionWrapper deviceType={deviceType}>
              <HowToConvert currencyData={currencyData} />
            </SectionWrapper>

            {currencyData?.benefits?.title && (
              <SectionWrapper deviceType={deviceType}>
                <Benefits currencyData={currencyData} />
              </SectionWrapper>
            )}

            <SectionWrapper deviceType={deviceType}>
              <OtherServices currencyData={currencyData} />
            </SectionWrapper>

            <SectionWrapper deviceType={deviceType}>
              <PopularDenomitations
                currencyData={currencyData}
                inrExchageRate={inrExchangeRate}
              />
            </SectionWrapper>

            <SectionWrapper deviceType={deviceType}>
              <CurrencyInformation currencyData={currencyData} />
            </SectionWrapper>

            <SectionWrapper deviceType={deviceType}>
              <OtherConversions currencyData={currencyData} />
            </SectionWrapper>

            <SectionWrapper deviceType={deviceType}>
              <CrossLobLinks
                crossLobSections={currencyData?.cross_lob_sections}
              />
            </SectionWrapper>

            {currencyData?.faqs?.list?.length > 0 && (
              <SectionWrapper deviceType={deviceType}>
                <Faqs currencyData={currencyData} />
              </SectionWrapper>
            )}
          </div>
        </div>
      </div>

      {currencyData?.footer ? (
        <CurrencyFooter footer={currencyData?.footer} />
      ) : null}
    </div>
  );
};
